export const QUERY_LIBRARY_TAB = 'libraryTab'

export const LibraryTabs = {
  FAVORITES: 'favorites',
  PURCHASED: 'purchased',
} as const
export type LibraryTabs = (typeof LibraryTabs)[keyof typeof LibraryTabs]

export type LibraryTabNames = {
  favorites: string
  purchased: string
}
